import { render, staticRenderFns } from "./AdminPanelEGiftsShoppingPacket.vue?vue&type=template&id=3be94e86&"
import script from "./AdminPanelEGiftsShoppingPacket.vue?vue&type=script&lang=js&"
export * from "./AdminPanelEGiftsShoppingPacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports